module.exports = __webpack_public_path__ + "media/images/sh-fd6265904f3694ef035592df3fc76ac9.png";